// Author Lin
// Date 2021-09-10 16:41:16

class SithMesMstBasicHeader {
        constructor({
                id = null,
                parentId = '',
                parentName = '',
                machineTypeId = '',
                hierarchicalRelationship = '',
                item = '',
                material = '',
                en = '',
                cn = '',
                qty = '',
                bomUnit = '',
                mtype = '',
                eF = '',
                activityId = '',
                wbsCode = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.parentId = parentId;
            this.parentName = parentName;
            this.machineTypeId = machineTypeId;
            this.hierarchicalRelationship = hierarchicalRelationship;
            this.item = item;
            this.material = material;
            this.en = en;
            this.cn = cn;
            this.qty = qty;
            this.bomUnit = bomUnit;
            this.mtype = mtype;
            this.eF = eF;
            this.activityId = activityId;
            this.wbsCode = wbsCode;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesMstBasicHeader();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'parentId',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.parentId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'parentName',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.parentName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.machineTypeId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'machineName',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.machineName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hierarchicalRelationship',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.hierarchicalRelationship',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'item',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.item',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'material',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.material',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'en',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.en',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cn',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.cn',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'qty',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.qty',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bomUnit',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.bomUnit',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mtype',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.mtype',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'eF',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.eF',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.activityId',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wbsCode',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.wbsCode',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBasicHeader.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : "",
            idListFilter : "",
            parentIdFilter : "",
            parentNameFilter : "",
            machineTypeIdFilter : "",
            hierarchicalRelationshipFilter : "",
            itemFilter : "",
            materialFilter : "",
            enFilter : "",
            cnFilter : "",
            qtyFilter : "",
            bomUnitFilter : "",
            mtypeFilter : "",
            eFFilter : "",
            activityIdFilter : "",
            wbsCodeFilter : ""
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'parentNameFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.parentName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstBasicHeader'
                    ,correspondingField: 'cn'
                    ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                        }
                },
                {
                key: 'machineTypeIdFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.machineTypeId',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'hierarchicalRelationshipFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.hierarchicalRelationship',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'itemFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.item',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'materialFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.material',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'enFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.en',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cnFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.cn',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'qtyFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.qty',
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bomUnitFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.bomUnit',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mtypeFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.mtype',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'eFFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.eF',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityIdFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.activityId',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'wbsCodeFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.wbsCode',
                disabled: false,
                form: {
                type: 'input'
                        }
                }
        ];
        const levelTreeFilterConfigs = [
                {
                key: 'cnFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.cn',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'machineTypeIdFilter',
                label: 'label.sith.mst.sithMesMstBasicHeader.filter.machineTypeId',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                        ,entity: 'sithMesMstMachineType'
                        ,correspondingField: 'id'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'parentId',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.parentId',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'parentName',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.parentName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'sithMesMstBasicHeader'
                    ,correspondingField: 'cn'
                    ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                        }
                },
                {
                key: 'machineTypeId',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.machineTypeId',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'sithMesMstMachineType'
                    ,correspondingField: 'id'
                        }
                },
                {
                key: 'hierarchicalRelationship',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.hierarchicalRelationship',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'item',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.item',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'material',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.material',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'en',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.en',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'cn',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.cn',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                    ,required: true
                        }
                },
                {
                key: 'qty',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.qty',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bomUnit',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.bomUnit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mtype',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.mtype',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'eF',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.eF',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'activityId',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.activityId',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'wbsCode',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.wbsCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstBasicHeader.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {SithMesMstBasicHeader, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs, levelTreeFilterConfigs
        
        
        }
        